import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="bg-warm-white py-16 md:py-24 px-4" data-id="element-119">
      <div className="max-w-3xl mx-auto text-center" data-id="element-120">
        <motion.div initial={{
        opacity: 0,
        scale: 0.8
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-sage/10 mb-8" data-id="element-121">
          <ShieldCheck className="w-10 h-10 text-sage" data-id="element-122" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} data-id="element-123">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-olive mb-6" data-id="element-124">
            Compra con tranquilidad
          </h2>

          <div className="space-y-4 text-lg text-warm-gray leading-relaxed" data-id="element-125">
            <p data-id="element-126">
              Tu compra está protegida por una garantía de 7 días. Si en los
              primeros días sientes que esta guía no es para ti, puedes
              solicitar tu reembolso y recibirás el 100% de tu dinero de vuelta.
              Sin preguntas. Sin complicaciones.
            </p>
            <p className="font-medium text-olive" data-id="element-127">
              Queremos que tomes esta decisión con calma y confianza.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}